import dayjs from "dayjs";
import { gql } from "@apollo/client";

export const HeatScheduleFragment = gql`
    fragment OnlyScheduledHeat on Heat {
        scheduledTime
    }
`;
export const updateSchedule = (client, event, data) => {
    if (!data.event || !event.fullSchedule.podiums) return;

    const currentIndex = data.event.currentScheduleIndex;
    const scheduleSize = Math.max(...event.fullSchedule.podiums.map(podium => podium.heats.length));
    const schedule = event.fullSchedule;
    const heats = schedule.podiums.map(podium => podium.heats);
    const currentHeats = data.event.currentHeats.filter(h => h);

    [...Array(scheduleSize)].reduce((scheduledTime, x, i) => {
        const heatsToUpdate = currentIndex === i ? currentHeats : heats.map(podiumHeats => podiumHeats[i]).filter(h => h);

        if (i > 0) {
            scheduledTime = dayjs(scheduledTime)
                .add(Math.max(...heats.map(podiumHeats => podiumHeats[i - 1]).filter(h => h).map(h => h.heatDurationMinutes)), "minute")
                .add(schedule.heatsIntervalSeconds, "second")
                .format();
        }

        const breaksHere = schedule.breaks.filter(b => b.position === i);
        scheduledTime = breaksHere.length ? breaksHere[breaksHere.length - 1].date : scheduledTime;
        scheduledTime = heatsToUpdate.map(h => h.startTime)[0] || scheduledTime;

        heatsToUpdate.forEach(heat => {
            if (dayjs(heat.scheduledTime).diff(scheduledTime))
                client.writeFragment({
                    id: `Heat:${heat.id}`,
                    fragment: HeatScheduleFragment,
                    data: { scheduledTime: dayjs(scheduledTime).format() }
                });
        });

        return scheduledTime;
    }, event.date);
};
